module.exports = __webpack_public_path__ + "img/canvasMenuCopy.30753ca9.svg";